// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AccessibilityRouteImport } from './routes/accessibility'
import { Route as CompareRouteImport } from './routes/compare'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as GuideRouteImport } from './routes/guide'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PanelRouteRouteImport } from './routes/panel/route'
import { Route as PayRouteRouteImport } from './routes/pay/route'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as VehiclesRouteImport } from './routes/vehicles'
import { Route as DTokenRouteImport } from './routes/d.$token'
import { Route as PanelIndexRouteImport } from './routes/panel/index'
import { Route as PanelClubRouteImport } from './routes/panel/club'
import { Route as PanelContractsRouteImport } from './routes/panel/contracts'
import { Route as PanelHistoryRouteImport } from './routes/panel/history'
import { Route as PanelInstallmentsRouteImport } from './routes/panel/installments'
import { Route as PanelOrdersRouteImport } from './routes/panel/orders'
import { Route as PanelProfileRouteImport } from './routes/panel/profile'
import { Route as PanelRequestsRouteImport } from './routes/panel/requests'
import { Route as PanelTransactionsRouteImport } from './routes/panel/transactions'
import { Route as VehiclesVehicleIdRouteImport } from './routes/vehicles_.$vehicleId'
import { Route as PanelAppointmentsIndexRouteImport } from './routes/panel/appointments/index'
import { Route as PanelAppointmentsNewRouteImport } from './routes/panel/appointments/new'
import { Route as PanelTicketsIndexRouteImport } from './routes/panel/tickets/index'
import { Route as PanelTicketsTicketIdRouteImport } from './routes/panel/tickets/$ticketId'
import { Route as PanelTicketsNewRouteImport } from './routes/panel/tickets/new'
import { Route as PanelVehiclesIndexRouteImport } from './routes/panel/vehicles/index'
import { Route as PanelVehiclesOwnedIdRouteImport } from './routes/panel/vehicles/$ownedId'
import { Route as PayCallbackPaymentIdRouteImport } from './routes/pay/callback.$paymentId'
import { Route as PayTestPaymentIdRouteImport } from './routes/pay/test.$paymentId'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AccessibilityRoute = AccessibilityRouteImport.update({
            id: '/accessibility',path: '/accessibility',getParentRoute: () => rootRouteImport
          })
const CompareRoute = CompareRouteImport.update({
            id: '/compare',path: '/compare',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const GuideRoute = GuideRouteImport.update({
            id: '/guide',path: '/guide',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const PanelRouteRoute = PanelRouteRouteImport.update({
            id: '/panel',path: '/panel',getParentRoute: () => rootRouteImport
          })
const PayRouteRoute = PayRouteRouteImport.update({
            id: '/pay',path: '/pay',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const VehiclesRoute = VehiclesRouteImport.update({
            id: '/vehicles',path: '/vehicles',getParentRoute: () => rootRouteImport
          })
const DTokenRoute = DTokenRouteImport.update({
            id: '/d/$token',path: '/d/$token',getParentRoute: () => rootRouteImport
          })
const PanelIndexRoute = PanelIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PanelRouteRoute
          })
const PanelClubRoute = PanelClubRouteImport.update({
            id: '/club',path: '/club',getParentRoute: () => PanelRouteRoute
          })
const PanelContractsRoute = PanelContractsRouteImport.update({
            id: '/contracts',path: '/contracts',getParentRoute: () => PanelRouteRoute
          })
const PanelHistoryRoute = PanelHistoryRouteImport.update({
            id: '/history',path: '/history',getParentRoute: () => PanelRouteRoute
          })
const PanelInstallmentsRoute = PanelInstallmentsRouteImport.update({
            id: '/installments',path: '/installments',getParentRoute: () => PanelRouteRoute
          })
const PanelOrdersRoute = PanelOrdersRouteImport.update({
            id: '/orders',path: '/orders',getParentRoute: () => PanelRouteRoute
          })
const PanelProfileRoute = PanelProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => PanelRouteRoute
          })
const PanelRequestsRoute = PanelRequestsRouteImport.update({
            id: '/requests',path: '/requests',getParentRoute: () => PanelRouteRoute
          })
const PanelTransactionsRoute = PanelTransactionsRouteImport.update({
            id: '/transactions',path: '/transactions',getParentRoute: () => PanelRouteRoute
          })
const VehiclesVehicleIdRoute = VehiclesVehicleIdRouteImport.update({
            id: '/vehicles_/$vehicleId',path: '/vehicles/$vehicleId',getParentRoute: () => rootRouteImport
          })
const PanelAppointmentsIndexRoute = PanelAppointmentsIndexRouteImport.update({
            id: '/appointments/',path: '/appointments/',getParentRoute: () => PanelRouteRoute
          })
const PanelAppointmentsNewRoute = PanelAppointmentsNewRouteImport.update({
            id: '/appointments/new',path: '/appointments/new',getParentRoute: () => PanelRouteRoute
          })
const PanelTicketsIndexRoute = PanelTicketsIndexRouteImport.update({
            id: '/tickets/',path: '/tickets/',getParentRoute: () => PanelRouteRoute
          })
const PanelTicketsTicketIdRoute = PanelTicketsTicketIdRouteImport.update({
            id: '/tickets/$ticketId',path: '/tickets/$ticketId',getParentRoute: () => PanelRouteRoute
          })
const PanelTicketsNewRoute = PanelTicketsNewRouteImport.update({
            id: '/tickets/new',path: '/tickets/new',getParentRoute: () => PanelRouteRoute
          })
const PanelVehiclesIndexRoute = PanelVehiclesIndexRouteImport.update({
            id: '/vehicles/',path: '/vehicles/',getParentRoute: () => PanelRouteRoute
          })
const PanelVehiclesOwnedIdRoute = PanelVehiclesOwnedIdRouteImport.update({
            id: '/vehicles/$ownedId',path: '/vehicles/$ownedId',getParentRoute: () => PanelRouteRoute
          })
const PayCallbackPaymentIdRoute = PayCallbackPaymentIdRouteImport.update({
            id: '/callback/$paymentId',path: '/callback/$paymentId',getParentRoute: () => PayRouteRoute
          })
const PayTestPaymentIdRoute = PayTestPaymentIdRouteImport.update({
            id: '/test/$paymentId',path: '/test/$paymentId',getParentRoute: () => PayRouteRoute
          })





const PanelRouteRouteChildren = {
  PanelClubRoute: PanelClubRoute,PanelContractsRoute: PanelContractsRoute,PanelHistoryRoute: PanelHistoryRoute,PanelInstallmentsRoute: PanelInstallmentsRoute,PanelOrdersRoute: PanelOrdersRoute,PanelProfileRoute: PanelProfileRoute,PanelRequestsRoute: PanelRequestsRoute,PanelTransactionsRoute: PanelTransactionsRoute,PanelIndexRoute: PanelIndexRoute,PanelAppointmentsNewRoute: PanelAppointmentsNewRoute,PanelTicketsTicketIdRoute: PanelTicketsTicketIdRoute,PanelTicketsNewRoute: PanelTicketsNewRoute,PanelVehiclesOwnedIdRoute: PanelVehiclesOwnedIdRoute,PanelAppointmentsIndexRoute: PanelAppointmentsIndexRoute,PanelTicketsIndexRoute: PanelTicketsIndexRoute,PanelVehiclesIndexRoute: PanelVehiclesIndexRoute
}

const PanelRouteRouteWithChildren = PanelRouteRoute._addFileChildren(PanelRouteRouteChildren)




const PayRouteRouteChildren = {
  PayCallbackPaymentIdRoute: PayCallbackPaymentIdRoute,PayTestPaymentIdRoute: PayTestPaymentIdRoute
}

const PayRouteRouteWithChildren = PayRouteRoute._addFileChildren(PayRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,PanelRouteRoute: PanelRouteRouteWithChildren,PayRouteRoute: PayRouteRouteWithChildren,AboutRoute: AboutRoute,AccessibilityRoute: AccessibilityRoute,CompareRoute: CompareRoute,ContactRoute: ContactRoute,GuideRoute: GuideRoute,LoginRoute: LoginRoute,PrivacyRoute: PrivacyRoute,TermsRoute: TermsRoute,VehiclesRoute: VehiclesRoute,DTokenRoute: DTokenRoute,VehiclesVehicleIdRoute: VehiclesVehicleIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)